import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/guides/icons/eye.svg")